import PropTypes from 'prop-types'
import React from 'react'
import Base from '../../containers/BaseContainer'
import { I18n } from 'react-redux-i18n'
import classNames from 'classnames'
import Modal from 'tg-modal'

import styles from './Alert.module.scss'

class Alert extends Base {

  constructor() {
    super()
    this._bind('_handleConfirm', '_handleCancel')
    this.state = {

    }
  }

  _handleConfirm() {
    if (this.props.opened && this.props.confirmAction) {
      this.props.confirmAction()
    }
  }

  _handleCancel() {
    if (this.props.opened && this.props.cancelAction) {
      this.props.cancelAction()
    }
  }

  render() {
    let confirmDisabled = this.props.confirmDisabled ? this.props.confirmDisabled : false
    let confirmClass = classNames(styles.confirmButton, confirmDisabled ? styles.disabled : null)

    return (
      <Modal
        isOpen={this.props.opened || false}
        onCancel={this._handleCancel}
        onConfirm={this._handleConfirm}>

        <Modal.Header addClose={false}>
          {I18n.t('Alert.' + this.props.messageTitle)}
        </Modal.Header>

        <Modal.Body>
          {this.props.body ? this.props.body : I18n.t('Alert.' + this.props.message)}
        </Modal.Body>

        <div className='tg-modal-footer'>
          {this.props.confirmAction
            ? <button
              onClick={this.props.confirmAction}
              className={confirmClass}
            >
              {I18n.t('Alert.' + this.props.confirmButtonTitle)}
            </button>
            : null
          }
          {this.props.cancelAction
            ? <button
              onClick={this.props.cancelAction}
              className={styles.cancelButton}
            >
              {I18n.t('Alert.' + this.props.cancelButtonTitle)}
            </button>
            : null
          }
        </div>
      </Modal>
    )
  }

}

Alert.propTypes = {
  opened: PropTypes.bool,
  alertStyle: PropTypes.string,
  message: PropTypes.string,
  messageTitle: PropTypes.string,
  body: PropTypes.object,
  confirmDisabled: PropTypes.bool,
  confirmButtonTitle: PropTypes.string,
  cancelButtonTitle: PropTypes.string,
  confirmAction: PropTypes.func,
  cancelAction: PropTypes.func,
}

export default Alert
